import React, { createContext, useContext, useState } from "react";

interface AppContextValue {
  hasVisitedHome: boolean;
  markVisitedHome: () => void;
  // You can add more app-wide state here
}

const AppContext = createContext<AppContextValue | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasVisitedHome, setHasVisitedHome] = useState(false);

  const markVisitedHome = () => setHasVisitedHome(true);

  return (
    <AppContext.Provider value={{ hasVisitedHome, markVisitedHome }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};

